import { render, staticRenderFns } from "./campaignDescription.vue?vue&type=template&id=c0acaf1a&"
import script from "./campaignDescription.vue?vue&type=script&lang=js&"
export * from "./campaignDescription.vue?vue&type=script&lang=js&"
import style0 from "./campaignDescription.vue?vue&type=style&index=0&id=c0acaf1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports